import { FC } from "react";

import { Heading, HStack, Text, VStack, Image, OrderedList, ListItem, Box } from "@chakra-ui/react";

const SharedDataBox: FC<{ variables: string[] }> = ({ variables }) => {
  return (
    <VStack
      bg="#F2F2F7"
      px={6}
      pt={4}
      pb={4}
      borderRadius={16}
      maxWidth="400px"
      width="calc(100% - 24px)"
      spacing={2}
      left="50%"
      right="12px"
    >
      <HStack width="100%">
        <Image src="/icons/steps.svg" alt="steps" objectFit="contain" borderRadius="16px" />
        <Heading as="h2" fontSize="18px" lineHeight="19px" fontWeight={500} color={"#1D2126"}>
          What am I sharing?
        </Heading>
      </HStack>

      <Box w={"100%"}>
        <OrderedList width="100%">
          {variables.length > 0 && (
            <>
              {variables.map((variable, index) => (
                <ListItem key={index}>
                  <Text
                    color="gray.600"
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight={400}
                    width="100%"
                    my={2}
                  >
                    {variable}
                  </Text>
                </ListItem>
              ))}
            </>
          )}
        </OrderedList>
      </Box>
    </VStack>
  );
};

export default SharedDataBox;
